<template>
    <div>
        <div class="rightTypeBox" v-loading="dataLoading">
            <div class="typeTitle">
            <span class="title">{{ dataObj.title }}</span>
            <div style="display:inline-block;padding:5px 0;vertical-align: top;cursor: pointer;">
                <div class="typeIcon">
                <i class="el-icon-caret-bottom" v-if="false"></i>
                <i class="el-icon-caret-top" v-else></i>
                </div>
            </div>
            <div style="float:right;display:inline-block;vertical-align: top;" v-if="false">
                <div class="allBtn">
                    全选
                </div>
                <div class="delBtn">
                    删除
                </div>
            </div>
            </div>
            <el-table
            :data="dataList"
            @row-click="rowCLick"
            style="width: 100%">
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                prop="contentTitle"
                label="文件名"
                width="585">
            </el-table-column>
            <el-table-column
                prop="createTime"
                label="收藏时间"
                width="160">
            </el-table-column>
            </el-table>
           <div v-if="dataTotal!=0">
                <el-pagination
                style="text-align:center;padding:20px 0;"
                @current-change="fgChange"
                :page-size="pageSize"
                layout="prev, pager, next"
                :total="dataTotal">
                </el-pagination>
           </div>
        </div>

        <div class="scDetail" v-if="isShowDetail" v-loading="scLoading">
            <div class="scDetailTop">
                <div class="scDetailClose" @click="closeDetail">×</div>
            </div>
            <div class="scDetailTitle">
                <span class="scDetailTitleLeft">问</span>
                <span>{{ detailObj.contentTitle }}</span>
            </div>
            <div class="scDetailAI">
                <div class="scDetailAILeft">
                    <img :src="imgObj.aiaiai_icon" alt="">
                </div>
                <div class="scDetailAIRight">
                    <span>以下答案由AI训练生成</span>
                </div>
            </div>
            <div class="scDetailText" v-if="detailObj.text">
                <NnitMarkdown
                id="notData"
                :source="detailObj.text"
                :showLine="false" />
            </div>
            <div class="scDetailHandle">
                <div class="scDetailHandleLeft">
                    <img :src="imgObj.date_icon" alt="">
                    <span>{{ detailObj.createTime }}</span>
                </div>
                <div class="scDetailHandleRight">
                    <div class="scDetailHandleCopy" @click="copyText(detailObj.text)">
                        <img v-if="isCopy==false" :src="imgObj.fu1" alt="">
                        <img v-else :src="imgObj.fu2" alt="">
                        <span v-if="isCopy==false">复制</span>
                        <span v-else style="color:#1571E5;">已复制</span>
                    </div>
                    <div class="scDetailHandleSC" @click="collection">
                        <img v-if="isCollection==false" :src="imgObj.shou1" alt="">
                        <img v-else :src="imgObj.shou2" alt="">
                        <span  v-if="isCollection==false">收藏</span>
                        <span  v-else style="color:#1571E5;">已收藏</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import { getCollection,sseCollection } from "@/api/api";

import aiaiai_icon from '@/assets/user/robot-trumpet-icon.png'
import date_icon from '@/assets/icon/date.png'
import fu1 from '@/assets/images/icon/fu1.png'
import fu2 from '@/assets/images/icon/fu2.png'
import shou1 from '@/assets/images/icon/shou1.png'
import shou2 from '@/assets/images/icon/shou2.png'


//组件
import NnitMarkdown from '@/components/unit-markdown/unit-markdown.vue'


export default {
    name:'',
    props:['sendData'],
    components:{
        NnitMarkdown
    },
    data(){
        return{
            imgObj:{
                aiaiai_icon,
                date_icon,
                fu1,
                fu2,
                shou1,
                shou2
            },
            sckey:'',
            dataObj:{},
            dataList:[],
            dataTotal:0,
            pageNo:1,
            pageSize:5,
            dataLoading:false,
            scLoading:false,
            isShowDetail:false,
            detailObj:{},
            isCollection:true,
            isCopy:false,
            
        }
    },
    created(){

    },
    mounted(){
        this.dataObj = this.$props.sendData;
        this.sckey = this.$props.sendData.scKey;
        this.getCollectionData();
    },
    methods:{
        getCollectionData(){
            let data = {
                pageSize: this.pageSize,
                pageNo: this.pageNo,
                catalogCode:this.sckey,
            }
            getCollection(data).then(res => {
                //console.log(res)
                this.dataList = res.data.rows;
                this.dataTotal = res.data.total;
                this.dataLoading = false;
            })
        },
        //分页
        fgChange(index){
            //console.log(index)
            this.pageNo = index;
            this.dataLoading = true;
            this.getCollectionData();
        },
        //行点击
        rowCLick(v){
            //console.log(v);
            this.detailObj = v;
            //展开详情
            this.isShowDetail = true;
        },
        //关闭
        closeDetail(){
            this.isShowDetail = false;
            this.detailObj = {};
            this.isCopy = false;
            this.isCollection = true;

            this.fgChange(this.pageNo)
        },
        //复制文字
        async copyText(text) {
            try {
                await navigator.clipboard.writeText(text);
                this.$message({
                    message:'文字已复制粘贴板!',
                    type:'success',
                })
                this.isCopy = true;
                //console.log('Text copied to clipboard');
            } catch (err) {
                //console.error('Failed to copy: ', err);
                this.$message({
                    message:'复制文字失败',
                    type:'error',
                })
                this.isCopy = false;
            }
        },
        //收藏和取消收藏
        collection(){
            this.scLoading = true;
            //
            if(this.isCollection==false){
                this.collectionAdd()
            }else{
                this.collectionCancel()
            }
        },
        //添加收藏
        collectionAdd(){
            let data = {}
            data.catalogCode = this.sckey,
            data.text =  this.detailObj.text,
            data.title = this.detailObj.contentTitle,
            sseCollection(data).then(res => {
                //console.log(res)
                if(res.status == 200&&res.data.status == 0){
                    this.collectionObj = res.data.data
                    this.$message({
                        message:'收藏成功',
                        type:'success',
                    })
                    this.isCollection = true;
                    this.scLoading = false;
                }
            })
        },
        //取消收藏
        collectionCancel(){
            let data = {}
            data.id = this.detailObj.id;
            sseCollection(data).then(res => {
                if(res.status == 200 &&res.data.status == 0){
                    console.log(res)
                    this.$message({
                        message:'取消收藏',
                        type:'success',
                    })
                    this.isCollection = false;
                    this.scLoading = false;
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.rightTypeBox{
        width: 100%;
        .typeTitle{
          width: 100%;
          height: 60px;
          background: #EEF8FF;
          box-sizing: border-box;
          padding: 15px 40px 15px 20px;
          span{
            display: inline-block;
          }
          .title{
            font-family: Source Han Sans CN;
            font-size: 20px;
            font-weight: bold;
            line-height: 30px;
            letter-spacing: 1em;
            color: #C22424;
          }
          .typeIcon{
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 2px;
            background: #1571E5;
            text-align: center;
            line-height: 20px;
            color: #FFFFFF;
            
          }
          .allBtn{
            width: 60px;
            height: 30px;
            border-radius: 4px;
            opacity: 1;
            background: #1571E5;
            margin-right: 30px;
            text-align: center;
            font-family: Source Han Sans CN;
            font-size: 16px;
            font-weight: normal;
            line-height: 30px;
            letter-spacing: 0.2em;
            color: #FFFFFF;
            cursor: pointer;
            display: inline-block;
          }
          .delBtn{
            width: 60px;
            height: 30px;
            border-radius: 4px;
            opacity: 1;
            background: #C22424;
            text-align: center;
            font-family: Source Han Sans CN;
            font-size: 16px;
            font-weight: normal;
            line-height: 30px;
            letter-spacing: 0.2em;
            color: #FFFFFF;
            cursor: pointer;
            display: inline-block;
          }
        }
      }

      .scDetail{
        width:1000px;
        //max-height:720px;
        background: #ffffff;
        position: fixed;
        top:60px;
        left:calc(50% - 500px);
        z-index: 999;
        box-sizing: border-box;
        padding:0 20px;
        box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.2);
        .scDetailTop{
            width:100%;
            height:60px;
            position: relative;
            .scDetailClose{
                width: 30px;
                height: 30px;
                background: #0F59A4;
                border-radius: 50%;
                position: absolute;
                right: 0px;
                top: 15px;
                color: #ffffff;
                font-size: 30px;
                text-align: center;
                line-height: 26px;
                cursor: pointer;
            }
        }
        .scDetailTitle{
            width:100%;
            line-height: 24px;
            .scDetailTitleLeft{
                line-height: 24px;
                background: #E7F0FF;
                border-radius:50%;
                padding:4px 8px;
                color:#1571E5;
                margin-right:8px;
                font-weight: 700;
            }
        }
        .scDetailAI{
            width:100%;
            height: 40px;
            line-height: 40px;
            margin-top:10px;
            background: #e5f2ff;
            .scDetailAILeft{
                width:40px;
                height: 40px;
                float:left;
                img{
                    width:40px;
                    height: 40px;
                    position: relative;
                }
            }
            .scDetailAIRight{
                width:calc(100% - 50px);
                height: 40px;
                float:left;
                margin-left:10px;
            }
            
        }
        .scDetailText{
            width:100%;
            max-height: 500px;
            overflow-y: auto;
            line-height: 24px;
            margin-top:10px;
        }
        .scDetailHandle{
            width:100%;
            height:40px;
            margin-top:10px;
            .scDetailHandleLeft{
                width:calc(100% - 200px);
                height:40px;
                float:left;
                img{
                    width:16px;
                    height:16px;
                    margin-right:6px;
                    position: relative;
                    top:1px;
                }
            }
            .scDetailHandleRight{
                width:200px;
                height:40px;
                float:left;
                img{
                    position: relative;
                    top:2px;
                    margin-right:2px;
                }
                .scDetailHandleCopy{
                    width:80px;
                    height:40px;
                    float:left;
                }
                .scDetailHandleSC{
                    width:80px;
                    height:40px;
                    float:left;
                    margin-left:10px;
                }
            }
        }
      }
</style>